import { checkHealthPlanCardEligibility } from '../services'
import { HealthPlanCardFormData } from '../components/modal/HealthPlanCard/types'
import { useMutation } from '@tanstack/react-query'

export const useCheckHealthCardExpiry = () => {
  return useMutation({
    mutationFn: (data: HealthPlanCardFormData) =>
      checkHealthPlanCardEligibility(data),
    retry: false,
  })
}
